import axios from "axios";
import { API_ENDPOINTS } from "./apiEndPoints";

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const token = (() => {
  try {
    const tokenStr = localStorage.getItem("token");
    return tokenStr ? JSON.parse(tokenStr) : null;
  } catch (error) {
    console.error("Error parsing token from localStorage:", error);
    return null;
  }
})();
export const fetchCMS = async () => {
  const response = await axios.get(`${baseUrl}${API_ENDPOINTS.cms}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchItemMaster = async () => {
  const response = await axios.get(`${baseUrl}${API_ENDPOINTS.itemMaster}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
export const fetchCategoriesByProduct = async (slug) => {
  const response = await axios.get(
    `${baseUrl}${API_ENDPOINTS?.ProductByCategory}/${slug}`
  );
  return response.data;
};
export const fetchProductBySlug = async (slug) => {
  const response = await axios.get(
    `${baseUrl}${API_ENDPOINTS?.ProductBySlug}/${slug}`
  );
  return response.data;
};
export const pageBySlug = async (slug) => {
  const response = await axios.get(
    `${baseUrl}${API_ENDPOINTS?.PageBySlug}/${slug}`
  );
  return response.data;
};
export const GetSettings = async () => {
  const response = await axios.get(`${baseUrl}${API_ENDPOINTS?.Settings}`);
  return response.data;
};

export const fetchUserOrders = async () => {
  const response = await axios.get(`${baseUrl}${API_ENDPOINTS.SalesOrderList}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchUserProfile = async () => {
  const tokenStr = localStorage.getItem("token");
  const currentToken = tokenStr ? JSON.parse(tokenStr) : null;

  if (!currentToken) {
    throw new Error("Not authenticated");
  }

  const response = await axios.get(`${baseUrl}${API_ENDPOINTS.Me}`, {
    headers: {
      Authorization: `Bearer ${currentToken}`,
    },
  });
  return response.data;
};

export const updateUserProfile = async (profileData, profileImage) => {
  const tokenStr = localStorage.getItem("token");
  const currentToken = tokenStr ? JSON.parse(tokenStr) : null;

  if (!currentToken) {
    throw new Error("Not authenticated");
  }

  const formData = new FormData();
  
  // Append profile fields
  Object.keys(profileData).forEach((key) => {
    if (profileData[key] !== null && profileData[key] !== undefined) {
      formData.append(key, profileData[key]);
    }
  });

  // Append profile image if provided - use profilePicture field for backend (user_profile table)
  if (profileImage) {
    formData.append("profilePicture", profileImage);
  }

  const response = await axios.post(
    `${baseUrl}${API_ENDPOINTS.UpdateProfile}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${currentToken}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};